<template>
    <div class="company-admin">
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="company-id" type="hidden" v-model="company.id" />
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Company Name:"
                        label-for="company-name_company"
                    >
                        <b-form-input
                            id="company-name_company"
                            type="text"
                            ref="searchFocus"
                            v-model="company.name_company"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Company Name.."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="Doc. Identification:" 
                        label-for="company-cnpj">
                        <b-form-input
                            id="company-cnpj"
                            type="text"
                            v-model="company.cnpj"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Doc. Identification..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="company.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="company-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="company-blocked"
                            >
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>

            
        </b-form>
        <b-row>
            <b-col xs="12">
                <b-button
                    title="Add"
                    size="sm"
                    class="mt-2 mb-2 fa fa-plus"
                    variant="dark"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                ></b-button>
                <b-button
                    title="Save"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                ></b-button>
                <b-button
                    title="Delete"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                ></b-button>
                <b-button
                    title="Back"
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                ></b-button>
                <b-button
                    size="sm"
                    title="Search"
                    class="mt-2 mb-2 ml-2 fa fa-search"
                    @click="
                        ;[
                            loadCompanys(),
                            toggleBusy(),
                            (showTable = !showTable),
                        ]
                    "
                    variant="dark"
                    v-show="mode !== 'save' && mode !== 'remove'"
                >
                </b-button>
            </b-col>
        </b-row>
        <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <div class="col-sm-6">
                <b-form-group>
                    <input
                        size="lg"
                        type="text"
                        icon="search"
                        v-model="search"
                        placeholder="Search by company name"
                        class="form-control"
                    />
                </b-form-group>
            </div>
            <transition name="slide" type="animation" appear>
                <b-table
                    :busy="isBusy"
                    class="table-responsive"
                    hover
                    key="slide"
                    head-variant="light"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="filteredList"
                    :fields="fields"
                >
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="View"
                            size="sm"
                            variant="light"
                            @click="loadcompany(data.item, 'read')"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button
                            title="Edit"
                            size="sm"
                            variant="light"
                            @click="loadcompany(data.item)"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button
                            title="Delete"
                            size="sm"
                            variant="light"
                            @click="loadcompany(data.item, 'remove')"
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="rows"
            >
            </b-pagination>
        </b-row>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import { mask } from 'vue-the-mask'
var moment = require('moment')

export default {
    name: 'companyAdmin',
    directives: { mask, moment },
    data: function() {
        return {
            mode: 'insert',
            company: {},
            storagefile: {},
            companys: [],
            states: [],
            citys: [],
            typeprices: [],
            taxregimeoptings: [],
            taxregimes: [],
            search: '',
            file: '',
            showTable: false,
            showSearch: true,
            isBusy: false,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'name_company', label: 'Company Name', sortable: true },
                { key: 'cnpj', label: 'Doc. Identification', sortable: false },
                {
                    key: 'blocked',
                    label: 'Blocked',
                    sortable: false,
                    formatter: value => (value ? 'Yes' : 'No'),
                },
                { key: 'actions', label: 'Action', variant: 'secondary' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.companys.filter(company => {
                return company.name_company
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.companys.length
        },
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data
                this.isBusy = false
            })
        },

        reset() {
            this.mode = 'insert'
            this.loadCompanys()
        },
        alterModo() {
            this.mode = 'save'
            this.company = {}
            this.$refs.searchFocus.focus()
        },
        remove() {
            const id = this.company.id
            axios
                .delete(`${baseApiUrl}/companys/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        save() {
            const method = this.company.id ? 'put' : 'post'
            const id = this.company.id ? `/${this.company.id}` : ''
            axios[method](`${baseApiUrl}/companys${id}`, this.company)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadStates() {
            const url = `${baseApiUrl}/states`
            axios.get(url).then(res => {
                this.states = res.data.map(state => {
                    return { value: state.id, text: state.initials }
                })
            })
        },
        loadCitys() {
            const id = this.company.state_id
            if (id) {
                const url = `${baseApiUrl}/citys/${id}`
                axios.get(url).then(res => {
                    this.citys = res.data.map(city => {
                        return { value: city.id, text: city.name }
                    })
                })
            }
        },
        loadCitysCounter() {
            const id = this.company.counter_state_id
            if (id) {
                const url = `${baseApiUrl}/citys/${id}`
                axios.get(url).then(res => {
                    this.citys = res.data.map(city => {
                        return { value: city.id, text: city.name }
                    })
                })
            }
        },
        loadcompany(company, mode = 'save') {
            this.mode = mode
            if (company.accounting_period_start)
                company.accounting_period_start = this.formatDate(
                    company.accounting_period_start
                )
            if (company.accounting_period_end)
                company.accounting_period_end = this.formatDate(
                    company.accounting_period_end
                )
            if (company.fixed_active_period_start)
                company.fixed_active_period_start = this.formatDate(
                    company.fixed_active_period_start
                )
            if (company.fixed_active_period_end)
                company.fixed_active_period_end = this.formatDate(
                    company.fixed_active_period_end
                )
            this.company = { ...company }
            this.loadCitys()
        },
        loadTypePrices() {
            const url = `${baseApiUrl}/typeprices`
            axios.get(url).then(res => {
                this.typeprices = res.data.map(typeprice => {
                    return {
                        value: typeprice.id,
                        text: typeprice.name_type_price,
                    }
                })
            })
        },
        loadTaxRegimes() {
            const url = `${baseApiUrl}/taxregimes`
            axios.get(url).then(res => {
                this.taxregimes = res.data.map(taxregime => {
                    return {
                        value: taxregime.id,
                        text: taxregime.tax_regime_name,
                    }
                })
            })
        },
        loadTaxRegimeOptions() {
            const url = `${baseApiUrl}/taxregimeoptings`
            axios.get(url).then(res => {
                this.taxregimeoptings = res.data.map(taxregimeopting => {
                    return {
                        value: taxregimeopting.id,
                        text: taxregimeopting.regime_tax_opting_name,
                    }
                })
            })
        },
        async saveImagem() {
            this.storagefile.user_id = this.user.id
            let formData = new FormData()
            formData.append('file', this.file)

            await axios
                .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },
    },
    mounted() {
        this.loadTaxRegimes()
        this.loadTaxRegimeOptions()
        this.loadStates()
        this.loadTypePrices()
        this.loadCompanys()

        this.showTable = true
    },
}
</script>

<style>

.company-admin  {
    font-size: 0.75rem;
    color: black;
}

.company-admin select {
    font-size: 0.75rem;
}
.company-admin input {
    font-size: 0.75rem;
}
.company-admin button {
    font-size: 0.75rem;
}
.company-admin table {
    font-size: 0.75rem;
}

.company-admin label {
    font-size: 0.75rem;
    color: black;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
